import { SERVICEWORKER_SCOPE } from './registerWebPushServiceWorker';

export default async function getWebPushRegistration(
    windowObj: Window
): Promise<ServiceWorkerRegistration> {
    let serviceWorker: ServiceWorkerContainer = windowObj.navigator.serviceWorker;
    let registrations = await serviceWorker.getRegistrations();
    let webPushRegistration = null;
    let origin: string = windowObj.location.origin + SERVICEWORKER_SCOPE;
    for (let i = 0; i < registrations.length; ++i) {
        if (registrations[i].scope.toLowerCase() == origin) {
            webPushRegistration = registrations[i];
            break;
        }
    }

    return webPushRegistration;
}
